<template>
  <div>
    <!--Modal AddEditLocalVotacion-->
    <div v-if="edit.mostrarModal">
      <add-edit-sub-region
        v-model="edit.mostrarModal"
        :sub-region-id="edit.subRegionId"
        @onSave="handleAddEditSubRegionSaved"
      ></add-edit-sub-region>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-form>
          <div class="card card-custom">
            <div class="card-header flex-wrap border-0 pt-6 pb-0">
              <div class="card-title">
                <h3 class="card-label">
                  <i class="fas fa-filter"></i> Filtros
                </h3>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <label class="font-weight-bold"> Región</label>
                  <select class="form-control" v-model="filter.regionId">
                    <option :value="null">- Seleccionar -</option>
                    <option
                      v-for="region in regiones"
                      :value="region.regionId"
                      :key="region.regionId"
                      >{{ region.nombre }}</option
                    >
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="font-weight-bold">Descripción</label>
                  <b-form-input
                    id="input-1"
                    v-model="filter.nombre"
                    required
                    placeholder="Buscar por nombre de sub región"
                  ></b-form-input>
                </div>
              </div>
            </div>
            <div class="card-footer padding-t-b">
              <div class="col-md-12">
                <a
                  href="#"
                  class="btn btn-primary font-weight-bold mr-2 alignment-right"
                  @click.prevent="fetchSubRegiones()"
                  ><i class="fa fa-search"></i> Buscar</a
                >
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <div class="card card-custom">
          <div class="card-header flex-wrap border-0 pt-6 pb-0">
            <div class="card-title">
              <h3 class="card-label">
                <i class="fa fa-fw fa-map-marker-alt"></i> Sub regiones
              </h3>
            </div>
            <div class="card-toolbar">
              <a
                href="#"
                class="btn btn-primary font-weight-bold mr-2"
                @click.prevent="doAddEditSubRegion()"
                ><i class="la la-plus"></i> Nuevo</a
              >
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table
                class="table table-head-custom table-vertical-center table-head-bg table-hover"
              >
                <thead>
                  <tr>
                    <th>Región</th>
                    <th>Sub región</th>
                    <th>Orden</th>
                    <th>Zona horaria</th>
                    <th>Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="subRegion in subRegiones"
                    :key="subRegion.subRegionId"
                  >
                    <td>
                      {{ subRegion.nombreRegion }}
                    </td>
                    <td>
                      {{ subRegion.nombre }}
                    </td>
                    <td>
                      {{ subRegion.orden }}
                    </td>
                    <td>
                      {{ subRegion.zonaHorariaDiffHoras }}
                    </td>
                    <td>
                      <b-dropdown right>
                        <template #button-content>
                          <i class="fas fa-ellipsis-v"></i>
                        </template>
                        <b-dropdown-item
                          href="#"
                          @click.prevent="
                            doAddEditSubRegion(subRegion.subRegionId)
                          "
                          ><span class="navi-icon"
                            ><i class="la la-pen text-dark"></i> Editar</span
                          ></b-dropdown-item
                        >
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cell-width-10 {
  width: 10%;
}

.cell-width-60 {
  width: 60%;
}

.cell-width-20 {
  width: 20%;
}

.alignment-right {
  float: right;
}

.padding-t-b {
  padding-top: 15px;
  padding-bottom: 15px;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Table from "../pages/vue-bootstrap/Table.vue";
import addEditSubRegion from "@/components/region/add-edit-sub-region";
import Swal from "sweetalert2";

/*intervalos de tiempo de Inactividad*/
import {
  INACTIVE_USER_TIME_THRESHOLD,
  USER_ACTIVITY_THROTTLER_TIME,
} from "@/helpers/constants.js";

export default {
  name: "list-sub-region",
  components: {
    addEditSubRegion,
  },
  props: {},
  data: () => ({
    subRegiones: [],
    edit: {
      mostrarModal: false,
      subRegionId: null,
    },
    pagination: {
      pageSize: 10,
    },
    filter: {
      regionId: null,
      nombre: "",
    },
    regiones: [],
    /*variables de inactividad*/
    isInactive: false,
    userActivityThrottlerTimeout: null,
    userActivityTimeout: null,
  }),
  computed: {},
  methods: {
    doAddEditSubRegion: function(subRegionId) {
      this.edit.mostrarModal = true;
      this.edit.subRegionId = subRegionId;
    },
    handleAddEditSubRegionSaved: function(obj) {
      //alert(JSON.stringify(obj));
      this.fetchSubRegiones();
    },
    fetchSubRegiones: function() {
      var modelSubRegion = {
        ...this.filter,
        ...this.pagination,
      };

      this.$http
        .post(this.apiRoute("Region", "ListSubRegiones"), modelSubRegion)
        .then(function(response) {
          this.subRegiones = response.body.data.items;
        });
    },
    fetchRegiones: function() {
      var modelRegion = {};
      this.$http
        .post(this.apiRoute("Region", "ListRegiones"), modelRegion)
        .then(function(response) {
          this.regiones = response.body.data.items;
        });
    },
    /*Metodos para verificar la inactividad del usuario*/
    activateActivityTracker: function() {
      window.addEventListener("mousedown", this.userActivityThrottler);
      window.addEventListener("mousemove", this.userActivityThrottler);
      window.addEventListener("scroll", this.userActivityThrottler);
      window.addEventListener("keydown", this.userActivityThrottler);
      window.addEventListener("resize", this.userActivityThrottler);
      window.addEventListener("touchstart", this.userActivityThrottler); //para dispositivos moviles
    },
    deactivateActivityTracker: function() {
      window.removeEventListener("mousedown", this.userActivityThrottler);
      window.removeEventListener("mousemove", this.userActivityThrottler);
      window.removeEventListener("scroll", this.userActivityThrottler);
      window.removeEventListener("keydown", this.userActivityThrottler);
      window.removeEventListener("resize", this.userActivityThrottler);
      window.removeEventListener("touchstart", this.userActivityThrottler); //para dispositivos moviles
    },
    resetUserActivityTimeout: function() {
      clearTimeout(this.userActivityTimeout);

      this.userActivityTimeout = setTimeout(() => {
        this.userActivityThrottler();
        this.inactiveUserAction();
      }, INACTIVE_USER_TIME_THRESHOLD); /*=> INACTIVE_USER_TIME_THRESHOLD */
    },
    userActivityThrottler: function() {
      if (this.isInactive) {
        this.isInactive = false;
      }

      if (!this.userActivityThrottlerTimeout) {
        this.userActivityThrottlerTimeout = setTimeout(() => {
          this.resetUserActivityTimeout();
          clearTimeout(this.userActivityThrottlerTimeout);
          this.userActivityThrottlerTimeout = null;
        }, USER_ACTIVITY_THROTTLER_TIME); /*=> USER_ACTIVITY_THROTTLER_TIME*/
      }
    },
    inactiveUserAction: function() {
      this.isInactive = true;

      Swal.fire({
        icon: "warning",
        title: "Sesión Expirada",
        text: "Su sesión ha expirado. Por favor vuelva a iniciar sesión.",
        confirmButtonText: `Iniciar Sesión`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.deactivateActivityTracker();
          clearTimeout(this.userActivityTimeout);
          clearTimeout(this.userActivityThrottlerTimeout);
          this.$router.push({ name: "login" });
        }
      });
    },
  },
  watch: {},
  mounted: function() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Sub - Regiones" }]);
    this.fetchRegiones();
    this.fetchSubRegiones();
    this.activateActivityTracker();
  },
  destoyed: function() {},
};
</script>
